
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"icon-hints","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"lines"},[_c('path',{staticClass:"line-r",attrs:{"d":"M61.64 31.9h-4.08a1.33 1.33 0 110-2.67h4.09a1.33 1.33 0 110 2.67z"}}),_c('path',{staticClass:"line-l",attrs:{"d":"M6.44 31.9H2.36a1.33 1.33 0 010-2.67h4.08a1.33 1.33 0 010 2.67z"}}),_c('path',{staticClass:"line-rt",attrs:{"d":"M50.06 14.1a1.33 1.33 0 01-.94-2.28L52 9a1.33 1.33 0 111.87 1.9L51 13.72a1.33 1.33 0 01-.94.38z"}}),_c('path',{staticClass:"line-lb",attrs:{"d":"M11 52.56a1.33 1.33 0 01-.94-2.28L13 47.41a1.33 1.33 0 011.87 1.9L12 52.18a1.33 1.33 0 01-1 .38z"}}),_c('path',{staticClass:"line-t",attrs:{"d":"M32 6.74a1.33 1.33 0 01-1.33-1.33V1.33a1.33 1.33 0 112.67 0v4.08A1.33 1.33 0 0132 6.74z"}}),_c('path',{staticClass:"line-lt",attrs:{"d":"M13.94 14.1a1.33 1.33 0 01-.94-.38l-2.9-2.87A1.33 1.33 0 1112 9l2.91 2.86a1.33 1.33 0 01-.94 2.28z"}}),_c('path',{staticClass:"line-rb",attrs:{"d":"M53 52.56a1.33 1.33 0 01-.94-.38l-2.91-2.86A1.33 1.33 0 1151 47.41l2.91 2.86a1.33 1.33 0 01-.91 2.29z"}})]),_c('path',{attrs:{"d":"M32 50.81a20.12 20.12 0 01-20.25-19.94 20.25 20.25 0 0140.5 0A20.12 20.12 0 0132 50.81z"}}),_c('path',{staticClass:"svg-b",attrs:{"d":"M32 13.59a17.45 17.45 0 00-17.58 17.28 17.58 17.58 0 0035.16 0A17.45 17.45 0 0032 13.59z"}}),_c('path',{attrs:{"d":"M38.59 57H25.41a1.33 1.33 0 110-2.67h13.18a1.33 1.33 0 110 2.67z"}}),_c('path',{attrs:{"d":"M35.43 64h-6.86a1.33 1.33 0 010-2.67h6.87a1.33 1.33 0 010 2.67z"}})])
          )
        }
      }
    